import { Stepper, Text } from '@mantine/core';

const CustomStepper = ({ steps, activeStep, onStepClick, isMobile, shouldAllowSelectStep }) => {
  return (
    <Stepper
      active={activeStep}
      onStepClick={onStepClick}
      color="#f20a61"
      iconSize={32}
      orientation="vertical"
    >
      {steps.map((step) => (
        <Stepper.Step
          key={step.number}
          label={
            isMobile ? '' : (
              <Text
                c={(step.number - 1) === activeStep ? '#f20a61' : 'black'}
                fw={(step.number - 1) === activeStep ? '700' : '400'}
                style={{
                  fontSize: 'clamp(0.8rem, 1vw, 1.2rem)', // Ajusta el tamaño dinámicamente
                }}
              >
                {step.title}
              </Text>
            )
          }
          description={isMobile ? '' : step.description}
          icon={step.icon}
          allowStepSelect={shouldAllowSelectStep(step.number - 1)}
        />
      ))}
    </Stepper>
  );
};

export default CustomStepper;